module.exports = __webpack_public_path__ + "assets/550ca902f83f764ce7e5155d5d549d9a.png";